import { createAction, props } from '@ngrx/store';
import { UploadIds, UploadKeys } from 'src/app/models/upload';

export const initializeUpload = createAction('[Upload] Initialize Upload', props<{ uuid: string }>());

export const uploadRequest = createAction(
  '[Upload] Upload Request',
  props<{ uuid: string; file: File; keyForUpload: UploadKeys; idsForUpload: UploadIds }>()
);

export const uploadCancel = createAction('[Upload] Upload Cancel', props<{ uuid: string }>());

export const uploadReset = createAction('[Upload] Upload Reset', props<{ uuid: string }>());

export const uploadStarted = createAction('[Upload] Upload Started', props<{ uuid: string }>());

export const uploadProgress = createAction('[Upload] Upload Started', props<{ uuid: string; progress: number }>());

export const uploadError = createAction('[Upload] Upload Error', props<{ uuid: string; error: any }>());

export const uploadCompleted = createAction('[Upload] Upload Completed', props<{ uuid: string; uploaded: File[] }>());

export const noopAction = createAction('[Upload] No Operations Action');
